<template>
    <div class="guide">
        <m_header/>
        <div class="content">
          <div class="title">
            <div @click="back()" class="container">
              <img src="../img/mobile/arrow.png" alt="">
              <span class="left">{{questionInfo.question}}</span>
            </div>
          </div>
          <div class="content questionContent" v-if="questionInfo">
              <div v-html="questionInfo.content">
              </div>
          </div>
        </div>
        <m_footer/>
    </div>
</template>

<script>
import m_header from './m_header'
import m_footer from './m_footer'
export default {
    name: 'm_guide',
    components: {
      m_header,
      m_footer
    },
    data: function () {
        return {
            questionInfo: '', // 问题详情
            activeQuestion: undefined
        }
    },
    methods: {
      back() {
        this.$router.push('m_guide')
      }
    },
    mounted() {
      var question_id = this.$route.query.question_id
      this.$utils.get('/help/question/read', {
                question_id: question_id
      }).then(res => {
          if(res.data.success) {
              this.questionInfo = res.data.data
          }
      })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.guide {
  height: 100%;
  position: relative;
  background-color: #fff;
  .content {
    min-height: calc(100% - 3.3rem);
    .title {
      height: 1.06rem;
      line-height: 1.06rem;
      border-bottom: 0.1rem solid #d6e1e5;
      .container {
        width: 100%;height: 100%;
      }
      img {
        width: 0.16rem;
        margin-left: 0.3rem;
        margin-top: 0.4rem;
        vertical-align: top;
      }
      .left {
        display: inline-block;
        font-size: 0.36rem;
        font-weight: bold;
        color: #364347;
        margin-left: 0.28rem;
        width: calc(100% - 0.96rem);
        height: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .questionContent {
      padding: 0.4rem 0.3rem;
      /deep/ div {
        strong {
            font-weight: bold;
        }
        h1,h2,h3,h4,h5,h6 {
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 20px;
        }
        table tr,td {
          border: 1px solid #ccc;
        }
        p {
          line-height: 1.6;
          margin-bottom: 20px;
          a {
            color: #0000ff;
          }
          strong {
              font-weight: bold;
          }
          em {
              font-style: italic;
          }
          img {
              max-width: 100%;
              height: auto !important;
              text-indent: 0;
              margin-bottom: 0px;
              // margin-top: 10px;
          }
          h1,h2,h3,h4,h5,h6 {
            font-weight: bold;
          }
        }
        video {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
